// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"94c376ed","72":"877d9937","108":"871fb35c","288":"acad91dd","355":"71f30962","491":"f63a3779","705":"acad91dd","890":"f0fe8f93","896":"e0c3d4c8"}[chunkId] + ".chunk.css";
};